module.exports = __webpack_public_path__ + "static/media/instagram-container.296cd195.svg";